export default {
      id: "train-usage",
      viewBox: "0 0 448 512",
      url: __webpack_public_path__ + "img/icons.6f915410.svg#train",
      toString: function () {
        return this.url;
      }
    }